var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_18676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0005 19H15.8305L20.7105 14.12C21.1005 13.73 21.1005 13.09 20.7105 12.7C20.3205 12.31 19.6905 12.31 19.3005 12.7L12.7105 19.29C12.3205 19.68 12.3205 20.31 12.7105 20.7L19.3005 27.29C19.6905 27.68 20.3205 27.68 20.7105 27.29C21.1005 26.9 21.1005 26.27 20.7105 25.88L15.8305 21H27.0005C27.5505 21 28.0005 20.55 28.0005 20C28.0005 19.45 27.5505 19 27.0005 19Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_18676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.1faf26ad124c165b8ab20a5c030ef83f.svg";
export { ForwardRef as ReactComponent };